<template>
    <div
        @dragover.prevent="onDragOver"
        @drop.prevent="onDrop"
        id="be-gallery"
        class="bg-light"
    >
        <div class="body-wrapper">

            <main class="pt-0 mt-0">

                <backend-gallery-header
                    :eventId="eventId"
                    :gallery="gallery"
                    :agents="agents"
                    :associatedAgent="associatedAgent"
                    :selectedAgent="selectedAgent"
                    @associateAgent="associateAgent"
                    @back="goToGalleries"
                />

                <div class="gallery d-flex justify-content-between flex-wrap position-relative">
                    <aside class="sidebar-fissa col-sm-3 px-0 bg-white border-right border-left border-bottom">
                        <div class="container-fluid my-3">
                            <div class="img-copertina-wrapper position-relative">
                                <div
                                    class="img-copertina w-100"
                                    v-bind:style="{ backgroundImage: 'url(' + this.getPhotoUrl(gallery.coverPhotoId) + ')' }"
                                >
                                    <a
                                        class="position-absolute w-100 h-100 d-inline-flex justify-content-center align-items-center text-white small p-2 text-center"
                                        v-if="gallery.coverPhotoId && gallery.coverPhotoId.length > 0"
                                    >
                                        <b-button
                                            variant="danger"
                                            @click="removeCover"
                                        >
                                            {{ $t("Rimuovi copertina") }}
                                        </b-button>
                                    </a>
                                    <!--<canvas ref="coverCanvas"></canvas>-->
                                </div>
                            </div>
                            <p class="mb-0 mt-2">
                                {{ $t("Scattata") }}:
                                {{ gallery.date | formatDate }}
                            </p>

                            <b-form-row class="mt-2 coupon">
                                <b-input-group class="px-2">
                                    <template v-slot:prepend>
                                        <b-input-group-text class="bg-white border-primary text-uppercase text-blurikorda font-titoli-rikorda">
                                            {{$t('Codice evento')}}
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input
                                        :value="gallery.coupon"
                                        readonly
                                        class="bg-white border-primary"
                                        ref="couponInput"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-button
                                            variant="primary"
                                            class="rounded-right"
                                            id="copy-coupon-btn"
                                            @click="copyCoupon"
                                        >
                                            <font-awesome-icon :icon="['fas', 'copy']" />
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-row>

                            <b-form-input
                                :value="gallery.link"
                                readonly
                                ref="linkInput"
                                class="d-none"
                            ></b-form-input>

                            <button
                                type="button"
                                class="pulsante-impostazioni-gallery mt-5 btn btn-light border w-100"
                                @click="goToGallerySettings"
                            >
                                {{ $t("Impostazioni Evento") }}
                            </button>
                            <hr />
                            <div v-if="hasAssociatedAgent()">
                                {{$t('Gallery assegnata al collaboratore ')}}
                                <p>{{associatedAgent.nome + ' ' + associatedAgent.cognome}}</p>
                                <a
                                    v-if="!isAgent"
                                    v-b-modal.remove-associate-event-agent-modal
                                >
                                    ( {{$t('Rimuovi collaboratore dalla gallery')}} )
                                </a>
                            </div>
                        </div>
                    </aside>

                    <div class="col-sm-9 offset-sm-3 px-0">
                        <div class="container-fluid px-0">

                            <!-- TABS x EVENTO -->
                            <b-tabs v-model="tabIndex">
                                <b-tab
                                    :title="$t('FOTO DELL\'EVENTO')"
                                    active
                                    :lazy="!isUploading"
                                >

                                    <div class="controlli-gallery mt-3 d-flex justify-content-end align-items-center flex-wrap">
                                        <div class="d-flex justify-content-start justify-content-lg-end align-items-center col-12 mt-3 mt-lg-0">

                                            <b-dropdown
                                                right
                                                variant="light border"
                                                class="dropdown-ordinamento ml-1"
                                            >
                                                <template v-slot:button-content>
                                                    <span class="current-selection-label">{{ sortTypes[gallery.sortField][gallery.sortType] }}</span>
                                                </template>
                                                <b-dropdown-item @click="orderBy('NAME', 'ASC')">
                                                    {{ sortTypes['NAME']['ASC'] }}
                                                    <font-awesome-icon
                                                        :icon="['fa', 'check']"
                                                        v-if="(gallery.sortField=='NAME' && gallery.sortType=='ASC')"
                                                    />
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="orderBy('NAME', 'DESC')">
                                                    {{ sortTypes['NAME']['DESC'] }}
                                                    <font-awesome-icon
                                                        :icon="['fa', 'check']"
                                                        v-if="(gallery.sortField=='NAME' && gallery.sortType=='DESC')"
                                                    />
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="orderBy('DATE', 'ASC')">
                                                    {{ sortTypes['DATE']['ASC'] }}
                                                    <font-awesome-icon
                                                        :icon="['fa', 'check']"
                                                        v-if="(gallery.sortField=='DATE' && gallery.sortType=='ASC')"
                                                    />
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="orderBy('DATE', 'DESC')">
                                                    {{ sortTypes['DATE']['DESC'] }}
                                                    <font-awesome-icon
                                                        :icon="['fa', 'check']"
                                                        v-if="(gallery.sortField=='DATE' && gallery.sortType=='DESC')"
                                                    />
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="orderBy('DATE_UPLOAD', 'ASC')">
                                                    {{ sortTypes['DATE_UPLOAD']['ASC'] }}
                                                    <font-awesome-icon
                                                        :icon="['fa', 'check']"
                                                        v-if="(gallery.sortField=='DATE_UPLOAD' && gallery.sortType=='ASC')"
                                                    />
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="orderBy('DATE_UPLOAD', 'DESC')">
                                                    {{ sortTypes['DATE_UPLOAD']['DESC'] }}
                                                    <font-awesome-icon
                                                        :icon="['fa', 'check']"
                                                        v-if="(gallery.sortField=='DATE_UPLOAD' && gallery.sortType=='DESC')"
                                                    />
                                                </b-dropdown-item>
                                            </b-dropdown>

                                            <b-dropdown
                                                right
                                                variant="light border"
                                                class="ml-1"
                                            >
                                                <template v-slot:button-content>
                                                    {{ $t("Altro") }}
                                                </template>
                                                <b-dropdown-item @click="removeAllPhotos()">{{ $t("Rimuovi tutte") }}
                                                </b-dropdown-item>
                                            </b-dropdown>

                                        </div>
                                    </div>

                                    <b-progress
                                        :value="uploadingLowResVal"
                                        :max="uploadingLowResMax"
                                        show-value
                                        animated
                                        :class="{'invisible' : !uploadingLowRes}"
                                    >
                                    </b-progress>

                                    <div
                                        class="d-none justify-content-start flex-wrap drop-area-container"
                                        :class="{ 'd-flex': !galleryHasPhoto }"
                                    >
                                        <div class="col-12 drop-area-msg">
                                            <p class="mb-0 text-center h1">
                                                <font-awesome-icon :icon="['fas', 'images']" />
                                            </p>
                                            <p class="mb-0 mt-3 text-center"> {{$t("Trascina qui le foto per caricarle")}} </p>
                                            <p class="mb-0 mt-3 text-center">{{$t("oppure")}}</p>
                                            <p class="mb-0 mt-3 text-center">
                                                <button
                                                    type="button"
                                                    class="ml-1 btn btn-light border"
                                                    @click="openFilesSelection"
                                                >
                                                    {{ $t("Aggiungi foto") }}
                                                </button>
                                            </p>
                                        </div>

                                        <redarea-uploader
                                            class="col-12"
                                            ref="redareaUploader"
                                            :user-id="gallery.userId"
                                            :album-id="gallery.galleryId"
                                            :uploader1ResizeDim="maxLresSize"
                                            :uploader2ResizeDim="maxHresSize"
                                            @uploaderMounted="redareaUploaderMounted"
                                            @filesAdded="onFilesAdded"
                                        >
                                        </redarea-uploader>
                                    </div>

                                    <ul
                                        class="griglia-foto d-none justify-content-start flex-wrap"
                                        :class="{ 'd-flex': galleryHasPhoto }"
                                    >
                                        <li class="foto-wrapper col-6 col-md-4 col-lg-3 mt-3">
                                            <div class="pulsante-aggiungi-foto-container">
                                                <button
                                                    type="button"
                                                    class="btn pulsante-aggiungi-foto"
                                                    @click="openFilesSelection"
                                                >
                                                    <font-awesome-icon :icon="['fa', 'plus']" /><br>{{ $t("Aggiungi foto") }}
                                                </button>
                                            </div>
                                        </li>

                                        <li
                                            class="foto-wrapper col-6 col-md-4 col-lg-3 mt-3"
                                            v-for="(photo, photoIndex) in photos"
                                            :key="photoIndex"
                                        >
                                            <gallery-photo-preview
                                                :ref="'preview-' + photoIndex"
                                                :photo="photo"
                                                @setAsCover="setCover"
                                                @save="renamePhoto"
                                                @edit="showEditPhotoModal"
                                                @remove="showRemovePhotoModal"
                                                @show="showPhotoShow"
                                                @retryUploadLowRes="retryUploadLowRes"
                                                @retryUploadHighRes="retryUploadHighRes"
                                            >
                                            </gallery-photo-preview>
                                        </li>
                                    </ul>
                                </b-tab>

                                <b-tab
                                    :title="$t('PROGETTI DELL\'EVENTO')"
                                    lazy
                                >

                                    <div class="controlli-gallery mt-3 d-flex justify-content-end align-items-center flex-wrap">
                                        <div class="d-flex justify-content-start justify-content-lg-end align-items-center col-12 mt-3 mt-lg-0">
                                            <b-dropdown
                                                right
                                                variant="light border"
                                                class="dropdown-categoria"
                                            >
                                                <template v-slot:button-content>
                                                    <span class="current-selection-label">{{ projectTypes[projectsFilters.projectType] }}</span>
                                                </template>

                                                <b-dropdown-item
                                                    v-for="(value, key) in projectTypes"
                                                    :key="key"
                                                    @click="filterProjectsByType(key)"
                                                >
                                                    {{value}}
                                                    <font-awesome-icon
                                                        :icon="['fa', 'check']"
                                                        v-if="projectsFilters.projectType==key"
                                                    />
                                                </b-dropdown-item>
                                            </b-dropdown>

                                            <b-dropdown
                                                right
                                                variant="light border"
                                                class="dropdown-ordinamento ml-1"
                                            >
                                                <template v-slot:button-content>
                                                    <span class="current-selection-label">{{ projectsSortTypes[projectsFilters.sortField][projectsFilters.sortType] }}</span>
                                                </template>
                                                <b-dropdown-item @click="filterProjectsBySort('NAME', 'ASC')">
                                                    {{ projectsSortTypes['NAME']['ASC'] }}
                                                    <font-awesome-icon
                                                        :icon="['fa', 'check']"
                                                        v-if="(projectsFilters.sortField=='NAME' && projectsFilters.sortType=='ASC')"
                                                    />
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="filterProjectsBySort('NAME', 'DESC')">
                                                    {{ projectsSortTypes['NAME']['DESC'] }}
                                                    <font-awesome-icon
                                                        :icon="['fa', 'check']"
                                                        v-if="(projectsFilters.sortField=='NAME' && projectsFilters.sortType=='DESC')"
                                                    />
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="filterProjectsBySort('DATE', 'ASC')">
                                                    {{ projectsSortTypes['DATE']['ASC'] }}
                                                    <font-awesome-icon
                                                        :icon="['fa', 'check']"
                                                        v-if="(projectsFilters.sortField=='DATE' && projectsFilters.sortType=='ASC')"
                                                    />
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="filterProjectsBySort('DATE', 'DESC')">
                                                    {{ projectsSortTypes['DATE']['DESC'] }}
                                                    <font-awesome-icon
                                                        :icon="['fa', 'check']"
                                                        v-if="(projectsFilters.sortField=='DATE' && projectsFilters.sortType=='DESC')"
                                                    />
                                                </b-dropdown-item>
                                            </b-dropdown>

                                            <b-input-group
                                                size="sm"
                                                class="ml-1 input-cerca-progetti"
                                                v-if="tabIndex==1"
                                            >
                                                <b-form-input
                                                    type="search"
                                                    placeholder="Cerca per nome progetto"
                                                    class="rounded-pill rilievo-ombra-interna"
                                                    v-model="projectsFilters.name"
                                                    @update="filterProjects"
                                                >
                                                </b-form-input>
                                                <font-awesome-icon :icon="['fas', 'search']" />
                                            </b-input-group>
                                        </div>
                                    </div>

                                    <ul class="griglia-progetti d-flex justify-content-start flex-wrap">
                                        <li class="progetto-wrapper col-12 col-md-6 mt-3">
                                            <button
                                                type="button"
                                                class="btn pulsante-aggiungi-progetto"
                                                @click="onAddProject"
                                            >
                                                <div class="d-flex justify-content-center align-items-center">
                                                    <font-awesome-icon :icon="['fa', 'plus']" />
                                                    <span class="txt-out">{{ $t("Aggiungi un progetto") }}<br><span class="txt-in">{{ $t("(cerca un progetto in Rikorda per la condivisione)") }}</span></span>
                                                </div>
                                            </button>
                                        </li>

                                        <li
                                            class="progetto-wrapper col-12 col-md-6 mt-3"
                                            v-for="(project, i) in filteredProjects"
                                            :key="'project-'+i"
                                        >
                                            <gallery-project
                                                :eventId="eventId"
                                                :gallery="gallery"
                                                :project="project"
                                                :mode="'edit'"
                                                @share="editProjectShare(project)"
                                                @unshare="removeProjectShare(project.idProgetto, i)"
                                            />
                                        </li>
                                    </ul>
                                </b-tab>
                            </b-tabs>

                        </div>

                        <backend-footer />

                    </div>
                </div>
            </main>

            <!-- popup inquadramento foto -->
            <b-modal
                id="edit-photo-modal"
                ref="edit-photo-modal"
                :title="$t('Inquadra la foto')"
                footer-class="justify-content-center"
                :no-close-on-esc="false"
                :no-close-on-backdrop="false"
            >
                <cropper
                    ref="cropper"
                    classname="cropper"
                    :src="editPhotoData.url"
                    :stencilProps="editPhotoData.stencilProps"
                    :canvas="false"
                    :minWidth="editPhotoData.minWidth"
                    :minHeight="editPhotoData.minHeight"
                    :wheelResize="false"
                    @ready="onCropperReady"
                    @change="onCropperChange"
                >
                </cropper>

                <p class="mb-0 mt-3 text-center">{{ editPhotoData.name }}</p>

                <template v-slot:modal-footer="{}">
                    <button
                        type="button"
                        class="btn btn-rikorda2"
                        v-visible="editPhotoIndex > 0"
                        @click="updateEditPhoto(editPhotoIndex - 1)"
                    >
                        <font-awesome-icon :icon="['fas', 'chevron-left']" />
                    </button>

                    <span class="d-inline-block">{{ 1 + editPhotoIndex }} {{ $t("di") }}
                        {{ editPhotosList.length }}</span>

                    <button
                        type="button"
                        class="btn btn-rikorda2"
                        v-visible="editPhotoIndex < editPhotosList.length - 1"
                        @click="updateEditPhoto(editPhotoIndex + 1)"
                    >
                        <font-awesome-icon :icon="['fas', 'chevron-right']" />
                    </button>
                </template>
            </b-modal>

            <!-- popup cancellazione foto -->
            <b-modal
                id="remove-photo-modal"
                ref="remove-photo-modal"
                :title="$t('Rimuovi la foto')"
            >
                <p class="mb-0">
                    {{
                        $t(
                            "La foto non sarà più accessibile. Questa operazione non può essere annullata!"
                        )
                    }}
                </p>

                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button
                        class="btn btn-light border"
                        @click="cancel()"
                    >
                        {{ $t("Annulla") }}
                    </b-button>
                    <b-button
                        class="btn btn-danger"
                        @click="ok()"
                    >
                        {{ $t("Rimuovi") }}
                    </b-button>
                </template>
            </b-modal>

            <!-- popup invio alte risoluzioni -->
            <b-modal
                id="upload-high-res-progress-modal"
                ref="upload-high-res-progress-modal"
                :title="$t('Invio foto ancora in corso. Attendere prego...')"
                size="lg"
            >
                <b-container fluid>
                    <b-row
                        v-for="photo in hresInProgress"
                        :key="photo.id"
                        class="mb-2"
                        align-v="center"
                        align-h="center"
                    >
                        <b-col
                            sm="3"
                            class="text-center"
                            style="height: 4rem"
                        >
                            <img
                                :src="getPhotoUrl(photo.photoId)"
                                class="h-100 text-center"
                            >
                        </b-col>
                        <b-col
                            sm="7"
                            class="text-center"
                        >
                            <div class="text-truncate">{{photo.name}}</div>
                            <b-progress
                                :value="photo.hresProgress"
                                max="100"
                                animated
                                v-if="photo.hresProgress > -1"
                            />
                            <div v-if="photo.hresProgress === -1">{{$t("Upload fallito. Riprova o cancella.")}}</div>
                        </b-col>
                        <b-col
                            sm="1"
                            class="text-center"
                        >
                            <b-button
                                variant="danger"
                                @click="retryUploadHighRes(photo.id)"
                                v-if="photo.hresProgress === -1"
                            >
                                <font-awesome-icon :icon="['fas', 'undo']" />
                            </b-button>
                        </b-col>
                        <b-col
                            sm="1"
                            class="text-center"
                        >
                            <b-button
                                variant="primary"
                                @click="removePhotos([photo.photoId])"
                            >
                                <font-awesome-icon :icon="['fas', 'times']" />
                            </b-button>
                        </b-col>
                    </b-row>
                </b-container>

                <template v-slot:modal-footer="{ cancel }">
                    <b-button
                        class="btn btn-light border"
                        @click="cancel()"
                    >
                        {{ $t("Chiudi") }}
                    </b-button>
                </template>
            </b-modal>

            <!-- popup rimozione associazione evento agente -->
            <b-modal
                id="remove-associate-event-agent-modal"
                title="Rimuovi collaboratore"
                ok-title="Rimuovi"
                cancel-title="Annulla"
                :ok-variant="'danger'"
                @ok.prevent="removeAssociateAgent"
                ref="removeAssociateAgentModal"
            >
                {{$t('Sei sicuro di voler rimuovere il collaboratore')}}?
                {{$t('Saranno rimossi dall\'evento anche gli eventuali progetti creati dal collaboratore')}}.
            </b-modal>
        </div>

        <!--gallery-photo-show
            :photo="photoToShow"
            v-show="isPhotoShowVisible"
            @hide="hidePhotoShow"
        ></gallery-photo-show-->
        <b-modal
            id="gallery-photo-show-modal"
            ref="gallery-photo-show-modal"
            :size="(photoToShow && (photoToShow['lres-width']>photoToShow['lres-height'])) ? 'lg' : ''"
            centered
            hide-header
            hide-footer
        >
            <!--
                NOTA: per foto orizzontali usa size=lg altrimenti usa size di default (un pò più piccolina
                per non avere una modale da scorrere)
            -->
            <div class="gallery-photo-show">
                <div class="text-center img bg-white">
                    <img :src="getZoomedPhotoUrl(photoToShow.photoId)">
                    <p class="mb-0 mt-1">
                        <span class="titolo-foto small">{{photoToShow.name}}</span>
                    </p>
                </div>
            </div>
        </b-modal>

        <notification
            :position="notificationPosition"
            :variant="notificationVariant"
            :message="notificationMessage"
            ref="notification"
        ></notification>

        <copy-link
            :link="gallery.link"
            @linkCopied="onGalleryLinkCopied"
        />
    </div>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";

import Notification from "../../components/Notification";
import BackendGalleryHeader from "../../components/backend/GalleryHeader";
import BackendFooter from "../../components/backend/Footer";
import GalleryPhotoPreview from "../../components/backend/GalleryPhotoPreview";
//import GalleryPhotoShow from "../../components/backend/GalleryPhotoShow";
import GalleryProject from "../../components/backend/GalleryProject";
import RedareaUploader from "../../components/backend/RedareaUploader";
import CopyLink from "../../components/CopyLink";
import naturalCompare from "natural-compare-lite";
import moment from "moment";

export default {
    name: "BackendGallery",

    components: {
        CopyLink,
        Cropper,
        Notification,
        BackendGalleryHeader,
        BackendFooter,
        GalleryPhotoPreview,
        //GalleryPhotoShow,
        GalleryProject,
        RedareaUploader
    },

    data() {
        return {
            //maxLresSize: 800, // DIMENSIONE LATO LUNGO IMMAGINE WEB
            maxLresSize: 750, // DIMENSIONE LATO LUNGO IMMAGINE WEB
            maxHresSize: 7620,
            eventId: "",
            gallery: { sortField: "DATE", sortType: "DESC" },
            photos: [],
            projects: [],
            agents: [],
            associatedAgent: {},
            selectedAgent: "",
            existingPhotos: [],
            uploadingLowRes: false,
            uploadingLowResVal: 0,
            uploadingLowResMax: 0,
            uploadingHighRes: false,
            filesAdded: false,
            editPhotosList: [],
            editPhotoIndex: "",
            editPhotoData: {},
            isPhotoShowVisible: false,
            photoToShow: {},
            notification: {
                time: 0,
                position: "bottom-right",
                variant: "",
                message: ""
            },
            tabIndex: 0,

            projectTypes: {
                all: "Visualizza Tutti",
                book: "Fotolibri",
                fotoarredo: "Arredo",
                "Idee Regalo": "Idee Regalo",
                "Biglietti e Cartoline": "Biglietti e Cartoline",
                Fotocalendari: "Calendari"
            },

            sortTypes: {
                NAME: {
                    ASC: "Nome file (crescente)",
                    DESC: "Nome file (decrescente)"
                },
                DATE: {
                    ASC: "Data scatto (crescente)",
                    DESC: "Data scatto (descrescente)"
                },
                DATE_UPLOAD: {
                    ASC: "Data invio (crescente)",
                    DESC: "Data invio (descrescente)"
                }
            },

            projectsSortTypes: {
                NAME: {
                    ASC: "Nome (crescente)",
                    DESC: "Nome (decrescente)"
                },
                DATE: {
                    ASC: "Data (crescente)",
                    DESC: "Data (decrescente)"
                }
            },

            projectsFilters: {
                projectType: "all",
                sortField: "DATE",
                sortType: "DESC",
                name: ""
            },
            filteredProjects: []
        };
    },

    computed: {
        galleryHasPhoto() {
            return this.photos && this.photos.length > 0;
        },

        isUploading() {
            var isUploading = false;
            if (this.galleryHasPhoto) {
                isUploading = this.uploadingLowRes || this.uploadingHighRes;
            }

            if (isUploading) {
                window.onbeforeunload = function (e) {
                    return "Uscendo dalla pagina le modifiche non salvate verranno perse";
                };
            } else {
                window.onbeforeunload = null;
            }
            return isUploading;
        },

        hresInProgress() {
            var inProgress = [];
            for (var i = 0; i < this.photos.length; i++) {
                if (
                    this.photos[i].photoId &&
                    this.photos[i].hresProgress < 100
                ) {
                    inProgress.push(this.photos[i]);
                }
            }
            return inProgress;
        },

        isAgent() {
            var userDataBE = this.$store.getters.userDataBE;
            var isAgent = this.$store.getters.isAgent;
            console.debug("USERDATABE", userDataBE);
            return userDataBE && isAgent;
        },

        notificationPosition() {
            return this.notification.position;
        },

        notificationVariant() {
            return this.notification.variant;
        },

        notificationMessage() {
            return this.notification.message;
        }
    },

    mounted() {
        this.eventId = this.$route.params.eventId;

        // attivazione tab specifico
        switch (this.$route.params.activeTab) {
            case "projects":
                this.tabIndex = 1;
                break;
            default:
                this.tabIndex = 0;
                break;
        }

        this.$api.backendGetGalleryData(this.eventId).then((response) => {
            console.log("BACKEND_GET_GALLERY_DATA", response);

            var cover = {};

            if (response.gallery) {
                this.gallery = response.gallery;
            }

            if (response.photos && response.photos.length > 0) {
                var i,
                    filesList = [],
                    photos = response.photos;

                for (i = 0; i < photos.length; i++) {
                    photos[i].targetRatio =
                        this.$imagesService.getTargetRatioForImage(
                            photos[i],
                            this.gallery.targetRatio
                        );

                    photos[i] = this.$imagesService.calculateCrop(
                        photos[i],
                        false
                    );

                    if (photos[i].photoId === this.gallery.coverPhotoId) {
                        cover = photos[i];
                    }

                    var imageData = photos[i];
                    var image = null;
                    try {
                        image = new File([], imageData.name, {
                            type: "image/jpeg"
                        });
                    } catch (e) {
                        image = new Blob([], { type: "image/jpeg" });
                        image.name = imageData.name;
                    }

                    if (image !== null) {
                        image.uploaded = true;
                        image.imageId = imageData.photoId;
                        image.width = imageData.width;
                        image.height = imageData.height;
                        image.rotation = imageData.rotation;
                        image.extraRotation = imageData.extraRotation || 0;
                        image.lresWidth = imageData["lres-width"];
                        image.lresHeight = imageData["lres-height"];
                        image.date = imageData.date;
                        image.dateUpload = imageData.dateUpload;
                        filesList.push(image);
                    }
                }

                this.existingPhotos = photos;

                if (filesList.length > 0) {
                    window.uploader.addImages(filesList);
                }
            }

            if (response.projects) {
                this.projects = response.projects;
                this.filterProjects();
            }

            if (response.agents) {
                this.agents = response.agents;
                this.associatedAgent = Object.keys(response.associatedAgent)
                    .length
                    ? response.associatedAgent
                    : {};
                this.selectedAgent = this.hasAssociatedAgent()
                    ? this.associatedAgent.fkUtente
                    : "";
            }

            if (cover.photoId) {
                cover["lres-crop"] =
                    this.$imagesService.calculateLresCrop(cover);
                cover.targetRatio = this.$imagesService.getTargetRatioForImage(
                    cover,
                    this.gallery.targetRatio
                );
                //this.drawCover(cover);
            }
        });

        this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
            if (modalId === "edit-photo-modal") {
                var i,
                    photosToUpdate = [];
                for (i = 0; i < this.editPhotosList.length; i++) {
                    if (
                        this.editPhotosList[i].crop.toString() !==
                        this.photos[i].crop.toString()
                    ) {
                        this.photos[i].crop = this.editPhotosList[i].crop;
                        this.photos[i]["lres-crop"] =
                            this.editPhotosList[i]["lres-crop"];
                        photosToUpdate.push(this.photos[i]);
                        this.$refs["preview-" + i][0].drawImageOnCanvas();

                        /*if (this.photos[i].photoId === this.gallery.coverPhotoId) {
                            this.drawCover(this.photos[i]);
                        }*/
                    }
                }

                this.editPhotosList = [];
                this.editPhotoIndex = "";
                this.editPhotoData = {};

                if (photosToUpdate.length > 0) {
                    this.savePhotos(photosToUpdate);
                }
            }
        });
    },

    methods: {
        onDragOver(event) {
            event.preventDefault();
        },
        onDrop(event) {
            event.preventDefault();
        },
        openFilesSelection() {
            this.filesAdded = false;
            this.$refs.redareaUploader.openFilesSelection();
        },
        onFilesAdded() {
            this.filesAdded = true;
        },

        redareaUploaderMounted() {
            var _this = this;

            //-- Gestione eventi uploder 1
            window.uploader.on("upload1-addedfile", function (file) {
                // qui possiamo disattivare il flag di controllo sui file aggiunti (per bloccare la navigazione)
                _this.filesAdded = false;

                var i,
                    imageData = null,
                    photo = {};
                for (i = 0; i < window.uploader.imagesData.length; i++) {
                    if (window.uploader.imagesData[i].file1 === file) {
                        imageData = window.uploader.imagesData[i];
                        break;
                    }
                }

                if (imageData !== null) {
                    var id = imageData.id;
                    var add = true;
                    for (i = 0; i < _this.photos.length; i++) {
                        if (_this.photos[i].id === id) {
                            add = false;
                            break;
                        }
                    }

                    if (add) {
                        var photoId = imageData.imageId;
                        var width = imageData.width;
                        var height = imageData.height;
                        var lresWidth = imageData.file1Width;
                        var lresHeight = imageData.file1Height;
                        var rotation =
                            window.RedareaUploaderHelpers.orientationToDegree(
                                imageData.exifData.Orientation
                            );
                        var date = imageData.date;
                        var dateUpload = imageData.dateUpload;

                        var crop = [0, 0, 0, 0],
                            lresCrop = [0, 0, 0, 0],
                            targetRatio = 1,
                            lresProgress = 0,
                            hresProgress = 0;
                        for (i = 0; i < _this.existingPhotos.length; i++) {
                            if (_this.existingPhotos[i].photoId === photoId) {
                                crop = _this.existingPhotos[i].crop;
                                lresCrop =
                                    _this.$imagesService.calculateLresCrop(
                                        _this.existingPhotos[i]
                                    );
                                targetRatio =
                                    _this.$imagesService.getTargetRatioForImage(
                                        _this.existingPhotos[i],
                                        _this.gallery.targetRatio
                                    );
                                lresProgress = 100;
                                hresProgress = 100;
                                break;
                            }
                        }

                        photo = {
                            id: id,
                            photoId: photoId,
                            name: file.name,
                            crop: crop,
                            width: width,
                            height: height,
                            "lres-width": lresWidth,
                            "lres-height": lresHeight,
                            "lres-crop": lresCrop,
                            rotation: rotation,
                            extraRotation: imageData.extraRotation,
                            targetRatio: targetRatio,
                            lresProgress: lresProgress,
                            hresProgress: hresProgress,
                            date: date,
                            dateUpload: dateUpload
                        };

                        _this.photos.push(photo);
                        file["id"] = id;
                    }
                }
            });

            window.uploader.on("upload1-start", function () {
                if (
                    _this.uploadMode ===
                    window.RedareaUploader.uploadModes.single
                ) {
                    _this.uploadingLowRes = true;
                    _this.uploadingHighRes = true;
                } else {
                    _this.uploadingLowRes = true;
                }
            });

            window.uploader.on(
                "upload1-success",
                async function (file, photoId) {
                    var i,
                        j,
                        id = file["id"];
                    for (i = 0; i < _this.photos.length; i++) {
                        if (_this.photos[i].id === id) {
                            _this.photos[i].photoId = photoId;

                            for (
                                j = 0;
                                j < window.uploader.imagesData.length;
                                j++
                            ) {
                                if (
                                    window.uploader.imagesData[j].imageId ===
                                    photoId
                                ) {
                                    let remoteImageData = false;
                                    if (
                                        ["image/heic", "image/heif"].includes(
                                            file.type
                                        )
                                    ) {
                                        let result =
                                            await _this.$api.backendGetImageData(
                                                photoId
                                            );
                                        remoteImageData = result.data;
                                    }

                                    if (remoteImageData) {
                                        _this.photos[i].width =
                                            remoteImageData.width;
                                        _this.photos[i].height =
                                            remoteImageData.height;

                                        _this.photos[i].name =
                                            remoteImageData.name;
                                        _this.photos[i]["lres-width"] =
                                            remoteImageData["lres-width"];
                                        _this.photos[i]["lres-height"] =
                                            remoteImageData["lres-height"];
                                        _this.photos[i]["lres-crop"] =
                                            _this.$imagesService.calculateLresCrop(
                                                _this.photos[i]
                                            );
                                    } else {
                                        _this.photos[i].width =
                                            window.uploader.imagesData[j].width;
                                        _this.photos[i].height =
                                            window.uploader.imagesData[
                                                j
                                            ].height;
                                    }

                                    _this.photos[i].rotation =
                                        window.RedareaUploaderHelpers.orientationToDegree(
                                            window.uploader.imagesData[j]
                                                .exifData.Orientation
                                        );
                                    _this.photos[i].targetRatio =
                                        _this.$imagesService.getTargetRatioForImage(
                                            _this.photos[i],
                                            _this.gallery.targetRatio
                                        );

                                    _this.photos[i] =
                                        _this.$imagesService.calculateCrop(
                                            _this.photos[i],
                                            true
                                        );
                                    _this.photos[i].lresProgress = 100;
                                    // data scatto da exif
                                    var dataScatto = window.uploader.imagesData[
                                        j
                                    ].exifData["DateTimeOriginal"]
                                        ? window.uploader.imagesData[j]
                                              .exifData["DateTimeOriginal"]
                                        : window.uploader.imagesData[j]
                                              .exifData["DateTime"]
                                        ? window.uploader.imagesData[j]
                                              .exifData["DateTime"]
                                        : null;
                                    _this.photos[i].date = dataScatto
                                        ? moment(
                                              String(dataScatto),
                                              "YYYY:MM:DD hh:mm:ss"
                                          ).format("YYYY-MM-DD hh:mm:ss")
                                        : null;
                                    // data invio
                                    _this.photos[i].dateUpload =
                                        moment().format("YYYY-MM-DD hh:mm:ss");
                                    _this.$refs[
                                        "preview-" + i
                                    ][0].drawImageOnCanvas();

                                    window.uploader.imagesData[
                                        j
                                    ].sendCrop = true;
                                    window.uploader.imagesData[j].crop =
                                        _this.photos[i].crop;

                                    //-- Se non ci sono foto, la prima uploadata viene settata come cover
                                    if (i === 0) {
                                        _this.setCover(_this.photos[0]);
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }
                }
            );

            window.uploader.on("upload1-progress", function (val, max) {
                _this.uploadingLowResVal = parseInt(val);
                _this.uploadingLowResMax = parseInt(max);
            });

            window.uploader.on("upload1-error", function (file, message) {
                var i,
                    index = -1,
                    id = "",
                    error = false;
                for (i = 0; i < window.uploader.imagesData.length; i++) {
                    if (window.uploader.imagesData[i].file1 === file) {
                        index = i;
                        id = window.uploader.imagesData[i].id;
                        break;
                    }
                }
                if (index > -1) {
                    //-- Se è un'immagine nera
                    if (
                        file.xhr.status === 402 &&
                        window.uploader.options.uploader1Resize.resize
                    ) {
                        if (window.uploader.imagesData[index].file1Retry < 3) {
                            window.uploader
                                .upload1ResizeImage(
                                    window.uploader.imagesData[index].file,
                                    index,
                                    false
                                )
                                .then(function (response) {
                                    window.uploader.uploader1.removeFile(file);
                                    window.uploader.uploader1.addFile(
                                        window.uploader.imagesData[index].file1
                                    );
                                    window
                                        .uploader.imagesData[index].file1Retry++;
                                    console.log(
                                        "Immagine nera - nuovo tentativo resize - " +
                                            window.uploader.imagesData[index]
                                                .file1Retry +
                                            " di 3"
                                    );
                                });
                        } else {
                            error = true;
                        }
                    } else {
                        if (window.uploader.imagesData[index].file1Retry < 3) {
                            window.uploader.imagesData[index].file1Retry++;
                            //-- nuovo tentativo dopo 5,10,15
                            setTimeout(function () {
                                _this.retryUploadLowRes(
                                    window.uploader.imagesData[index].id
                                );
                            }, window.uploader.imagesData[index].file1Retry *
                                5000);
                        } else {
                            error = true;
                        }
                    }

                    if (error) {
                        for (var j = 0; _this.photos.length; j++) {
                            if (_this.photos[j].id === id) {
                                _this.photos[j].lresProgress = -1;
                                break;
                            }
                        }
                    }
                }
            });

            window.uploader.on("upload1-end", function () {
                if (
                    _this.uploadMode ===
                    window.RedareaUploader.uploadModes.single
                ) {
                    _this.uploadingLowRes = false;
                    _this.uploadingHighRes = false;
                } else {
                    _this.uploadingLowRes = false;
                    window.uploader.upload2Start();
                }
            });

            //-- Gestione eventi uploder 2
            window.uploader.on("upload2-start", function () {
                _this.uploadingHighRes = true;
            });

            window.uploader.on("upload2-success", function (file, imageId) {
                for (var i = 0; i < _this.photos.length; i++) {
                    if (_this.photos[i].photoId === imageId) {
                        _this.photos[i].hresProgress = 100;
                    }
                }
            });

            window.uploader.on(
                "upload2-fileprogress",
                function (file, progress) {
                    var i,
                        photoId = "";
                    progress = parseInt(progress);
                    for (i = 0; i < window.uploader.imagesData.length; i++) {
                        if (window.uploader.imagesData[i].file === file) {
                            photoId = window.uploader.imagesData[i].imageId;
                            break;
                        }
                    }
                    for (i = 0; i < _this.photos.length; i++) {
                        if (_this.photos[i].photoId === photoId) {
                            _this.photos[i].hresProgress =
                                progress === 100 ? 99 : parseInt(progress);
                        }
                    }
                }
            );

            window.uploader.on("upload2-error", function (file) {
                var i,
                    index = -1,
                    photoId = "",
                    error = false;
                for (i = 0; i < window.uploader.imagesData.length; i++) {
                    if (window.uploader.imagesData[i].file2 === file) {
                        index = i;
                        photoId = window.uploader.imagesData[i].imageId;
                        break;
                    }
                }
                if (index > -1) {
                    if (file.xhr.status === 402) {
                        if (
                            window.uploader.imagesData[index].file2Retry < 3 &&
                            !window.uploader.imagesData[index].file.social &&
                            window.uploader.options.uploader2Resize.resize
                        ) {
                            window.uploader
                                .upload2ResizeImage(
                                    window.uploader.imagesData[index].file,
                                    index,
                                    false
                                )
                                .then(function (response) {
                                    window.uploader.uploader2.removeFile(file);
                                    window.uploader.uploader2.addFile(
                                        window.uploader.imagesData[index].file2
                                    );
                                    window
                                        .uploader.imagesData[index].file2Retry++;
                                    console.log(
                                        "Immagine nera - nuovo tentativo resize - " +
                                            window.uploader.imagesData[index]
                                                .file2Retry +
                                            " di 3"
                                    );
                                });
                        } else {
                            error = true;
                        }
                    } else {
                        if (window.uploader.imagesData[index].file2Retry < 3) {
                            window.uploader.imagesData[index].file2Retry++;
                            //-- nuovo tentativo dopo 5,10,15
                            setTimeout(function () {
                                _this.retryUploadHighRes(
                                    window.uploader.imagesData[index].id
                                );
                            }, window.uploader.imagesData[index].file2Retry *
                                5000);
                        } else {
                            error = true;
                        }
                    }

                    if (error) {
                        for (var j = 0; _this.photos.length; j++) {
                            if (_this.photos[j].photoId === photoId) {
                                _this.photos[j].hresProgress = -1;
                                break;
                            }
                        }
                    }
                }
            });

            window.uploader.on("upload2-end", function () {
                _this.uploadingHighRes = false;
                _this.$bvModal.hide("upload-high-res-progress-modal");
            });
        },

        retryUploadLowRes(id) {
            for (var i = 0; i < window.uploader.uploader1.files.length; i++) {
                if (
                    window.uploader.uploader1.files[i].status === "error" &&
                    window.uploader.uploader1.files[i].id === id
                ) {
                    window.uploader.uploader1.files[i].status = "queued";
                    break;
                }
            }
            window.uploader.uploader1.processQueue();
        },

        retryUploadHighRes(id) {
            for (var i = 0; i < window.uploader.uploader2.files.length; i++) {
                if (
                    window.uploader.uploader2.files[i].status === "error" &&
                    window.uploader.uploader2.files[i].id === id
                ) {
                    window.uploader.uploader2.files[i].status = "queued";
                    break;
                }
            }
            window.uploader.uploader2.processQueue();
        },

        showEditPhotoModal(photo) {
            this.editPhotosList = [];
            this.editPhotoIndex = "";
            this.editPhotoData = {};
            var i,
                index = 0;
            for (i = 0; i < this.photos.length; i++) {
                var coordinates = {
                    left: this.photos[i]["lres-crop"][0],
                    top: this.photos[i]["lres-crop"][1],
                    width: this.photos[i]["lres-crop"][2],
                    height: this.photos[i]["lres-crop"][3]
                };

                var imageW = this.photos[i].width;
                var imageH = this.photos[i].height;
                var imageRatio = imageW / imageH;
                var imageTargetRatio = this.photos[i].targetRatio;
                var cropperMinWidth = 10,
                    cropperMinHeight = 10;
                var minAllowedCropDim = Math.sqrt(
                    (this.gallery.qualityLowSize * 1000) /
                        this.gallery.targetRatio
                );
                var minAllowedCropDim2 =
                    minAllowedCropDim * this.gallery.targetRatio;

                if (
                    minAllowedCropDim > Math.min(imageW, imageH) ||
                    minAllowedCropDim2 >= Math.max(imageW, imageH)
                ) {
                    if (imageTargetRatio > imageRatio) {
                        cropperMinWidth = 100;
                    } else {
                        cropperMinHeight = 100;
                    }
                } else {
                    if (imageTargetRatio > imageRatio) {
                        cropperMinWidth = (minAllowedCropDim * 100) / imageW;
                    } else {
                        cropperMinHeight = (minAllowedCropDim * 100) / imageH;
                    }
                }

                this.editPhotosList.push({
                    photoId: this.photos[i].photoId,
                    name: this.photos[i].name,
                    width: imageW,
                    height: imageH,
                    "lres-width": this.photos[i]["lres-width"],
                    "lres-height": this.photos[i]["lres-height"],
                    crop: this.photos[i].crop,
                    url: this.$imagesService.getUrl(
                        this.photos[i].photoId,
                        "web"
                    ),
                    coordinates: coordinates,
                    stencilProps: { aspectRatio: imageTargetRatio },
                    minWidth: cropperMinWidth,
                    minHeight: cropperMinHeight
                });

                if (this.photos[i].photoId === photo.photoId) {
                    index = i;
                }
            }

            this.updateEditPhoto(index);
            this.$refs["edit-photo-modal"].show();
        },

        updateEditPhoto(index) {
            if (this.editPhotosList[index]) {
                this.editPhotoIndex = index;
                this.editPhotoData = this.editPhotosList[index];
            }
        },

        onCropperReady() {
            if (this.$refs.cropper) {
                this.$refs.cropper.setCoordinates(
                    this.editPhotoData.coordinates
                );
            }
        },

        onCropperChange({ coordinates, canvas }) {
            var lresCrop = [
                coordinates["left"],
                coordinates["top"],
                coordinates["width"],
                coordinates["height"]
            ];

            var photo = this.editPhotosList[this.editPhotoIndex];
            if (photo) {
                this.editPhotosList[this.editPhotoIndex].crop =
                    this.$imagesService.calculateHresCrop(photo, lresCrop);
                this.editPhotosList[this.editPhotoIndex]["lres-crop"] =
                    lresCrop;
            }
        },

        savePhotos(photos) {
            return this.$api.backendSaveGalleryPhotos(this.eventId, photos);
        },

        showRemovePhotoModal(photosList) {
            if (photosList.length > 0) {
                var _this = this;
                this.$refs["remove-photo-modal"].photosList = photosList;
                this.$refs["remove-photo-modal"].onOk = function () {
                    _this.removePhotos(
                        _this.$refs["remove-photo-modal"].photosList
                    );
                    _this.$refs["remove-photo-modal"].hide();
                };
                this.$refs["remove-photo-modal"].show();
            }
        },

        removePhotos(photosList) {
            var i, j;
            for (i = 0; i < photosList.length; i++) {
                for (j = 0; j < this.photos.length; j++) {
                    if (photosList[i] === this.photos[j].photoId) {
                        window.uploader.removeImage(this.photos[j].id);
                        this.photos.splice(j, 1);
                        /*if (photosList[i] === this.gallery.coverPhotoId) {
                            this.$imagesService.clearCanvas(this.$refs.coverCanvas);
                        }*/
                        break;
                    }
                }
            }

            this.$nextTick(function () {
                for (i = 0; i < this.photos.length; i++) {
                    this.$refs["preview-" + i][0].drawImageOnCanvas();
                }
            });

            return this.$api.backendRemoveGalleryPhotos(
                this.eventId,
                photosList
            );
        },

        removeAllPhotos() {
            var i,
                photosList = [];
            for (i = 0; i < this.photos.length; i++) {
                photosList.push(this.photos[i].photoId);
            }
            this.showRemovePhotoModal(photosList);
        },

        setCover(photo) {
            return this.$api
                .backendSetGalleryCover(this.eventId, photo.photoId)
                .then(() => {
                    this.gallery.coverPhotoId = photo.photoId;
                    //this.drawCover(photo);
                });
        },

        /*drawCover(photo) {
            var canvasW = this.$refs.coverCanvas.parentElement.clientWidth;
            var canvasH = this.$refs.coverCanvas.parentElement.clientHeight;
            var newCanvasW, newCanvasH;
            if (photo.targetRatio > 1) {
                newCanvasW = canvasW;
                newCanvasH = canvasW / photo.targetRatio;
                if (newCanvasH > canvasH) {
                    newCanvasH = canvasH;
                    newCanvasW = newCanvasH * photo.targetRatio;
                }
            } else {
                newCanvasH = canvasH;
                newCanvasW = canvasH * photo.targetRatio;
                if (newCanvasW > canvasW) {
                    newCanvasW = canvasW;
                    newCanvasH = newCanvasW * photo.targetRatio;
                }
            }
            this.$refs.coverCanvas.width = newCanvasW;
            this.$refs.coverCanvas.height = newCanvasH;
            this.$imagesService.drawImageOnCanvas(
                photo,
                this.$refs.coverCanvas
            );
        },*/

        getPhotoUrl(photoId) {
            return photoId ? this.$imagesService.getUrl(photoId, "web") : "";
        },

        getZoomedPhotoUrl(photoId) {
            return photoId
                ? this.$imagesService.getUrl(photoId, "event-web", "cropped")
                : "";
        },

        showPhotoShow(photo) {
            this.photoToShow = photo;
            this.isPhotoShowVisible = true;
            this.$bvModal.show("gallery-photo-show-modal");
        },

        hidePhotoShow() {
            this.isPhotoShowVisible = false;
            this.photoToShow = {};
        },

        renamePhoto(photo) {
            this.savePhotos([photo]).then(() => {
                for (var i = 0; i < this.photos.length; i++) {
                    if (this.photos[i].photoId === photo.photoId) {
                        this.photos[i].name = photo.name;
                        this.$refs["preview-" + i][0].isEditingName = false;
                        break;
                    }
                }
            });
        },

        copyCoupon() {
            var couponInput = this.$refs.couponInput.$el;
            couponInput.select();

            try {
                var successful = document.execCommand("copy");
            } catch (err) {
                successful = false;
            }

            if (successful) {
                this.notification.message = "Link evento copiato negli appunti";
                this.notification.variant = "success";
            } else {
                this.notification.message =
                    "Link evento non copiato negli appunti";
                this.notification.variant = "warning";
            }

            this.notification.position = "bottom-right";
            this.$refs.notification.time = 3000;

            window.getSelection().removeAllRanges();
        },

        removeCover() {
            return this.$api
                .backendSetEventSettings(this.eventId, { idCopertina: "" })
                .then((response) => {
                    this.gallery.coverPhotoId = "";
                });
        },

        onGalleryLinkCopied(successful) {
            if (successful) {
                this.notification.message = "Link evento copiato negli appunti";
                this.notification.variant = "success";
            } else {
                this.notification.message =
                    "Link evento non copiato negli appunti";
                this.notification.variant = "warning";
            }

            this.notification.position = "bottom-right";
            this.$refs.notification.time = 3000;

            window.getSelection().removeAllRanges();
        },

        goToGalleries() {
            this.$router.push({ name: "backend-galleries" });
        },

        goToGallerySettings() {
            this.$router.push({
                name: "backend-gallery-settings",
                params: { eventId: this.eventId }
            });
        },

        goToSearchProjects() {
            this.$router.push({
                name: "backend-gallery-projects-search",
                params: { eventId: this.eventId }
            });
        },

        hasAssociatedAgent() {
            return (
                typeof this.associatedAgent === "object" &&
                Object.keys(this.associatedAgent).length > 0
            );
        },

        associateAgent(localSelectedAgent) {
            let params = {
                fkEvento: this.eventId,
                fkUtenteAgente: localSelectedAgent
            };
            this.$api
                .backendAssociateAgentToEvent(params)
                .then((result) => {
                    console.debug("BACKEND_ASSOCIATE_AGENT_TO_EVENT", result);
                    this.associatedAgent = Object.keys(result.associatedAgent)
                        .length
                        ? result.associatedAgent
                        : {};
                    this.selectedAgent = this.hasAssociatedAgent()
                        ? this.associatedAgent.fkUtente
                        : "";
                })
                .catch((error) => {
                    console.error("BACKEND_ASSOCIATE_AGENT_TO_EVENT", error);
                });
        },

        removeAssociateAgent() {
            let params = {
                fkEvento: this.eventId,
                fkUtenteAgente: this.selectedAgent
            };
            this.$api
                .backendRemoveAssociationAgentToEvent(params)
                .then((result) => {
                    console.debug(
                        "BACKEND_REMOVE_ASSOCIATE_AGENT_TO_EVENT",
                        result
                    );
                    this.$refs.removeAssociateAgentModal.hide();
                    this.associatedAgent = {};
                    this.selectedAgent = "";
                })
                .catch((error) => {
                    console.error("BACKEND_ASSOCIATE_AGENT_TO_EVENT", error);
                });
        },

        orderBy(orderValue, orderType) {
            switch (orderValue) {
                case "NAME":
                    this.photos = this.photos.sort(function (a, b) {
                        return orderType == "ASC"
                            ? naturalCompare(
                                  a.name.toUpperCase(),
                                  b.name.toUpperCase()
                              )
                            : naturalCompare(
                                  b.name.toUpperCase(),
                                  a.name.toUpperCase()
                              );
                    });
                    break;

                case "DATE":
                    this.photos = this.photos.sort(function (a, b) {
                        let diff =
                            moment(String(a.date)) - moment(String(b.date));

                        console.log("DATE", a.date, b.date, diff);
                        if (diff < 0) {
                            return orderType == "ASC" ? -1 : 1;
                        } else if (diff > 0) {
                            return orderType == "ASC" ? 1 : -1;
                        } else {
                            // in caso di data uguale, ordina per titolo
                            return naturalCompare(
                                a.name.toUpperCase(),
                                b.name.toUpperCase()
                            );
                        }
                    });
                    break;

                case "DATE_UPLOAD":
                    this.photos = this.photos.sort(function (a, b) {
                        let diff =
                            moment(String(a.dateUpload)) -
                            moment(String(b.dateUpload));
                        console.log(
                            "DATE_UPLOAD",
                            a.dateUpload,
                            b.dateUpload,
                            diff
                        );
                        if (diff < 0) {
                            return orderType == "ASC" ? -1 : 1;
                        } else if (diff > 0) {
                            return orderType == "ASC" ? 1 : -1;
                        } else {
                            // in caso di data uguale, ordina per titolo
                            return naturalCompare(
                                a.name.toUpperCase(),
                                b.name.toUpperCase()
                            );
                        }
                    });
                    break;
            }

            var eventData = {
                sortField: orderValue,
                sortType: orderType
            };
            this.$api
                .backendSetEventSettings(this.eventId, eventData)
                .then((response) => {
                    this.gallery.sortField = orderValue;
                    this.gallery.sortType = orderType;
                });

            this.$nextTick(function () {
                for (let i = 0; i < this.photos.length; i++) {
                    this.$refs["preview-" + i][0].drawImageOnCanvas();
                }
            });
        },

        filterProjects() {
            this.filteredProjects = this.projects;

            if (this.projectsFilters.name) {
                this.filteredProjects = this.filteredProjects.filter(
                    (project) => {
                        if (project.titolo) {
                            return project.titolo
                                .toLowerCase()
                                .includes(
                                    this.projectsFilters.name.toLowerCase()
                                );
                        }
                        return false;
                    }
                );
            }

            if (this.projectsFilters.projectType != "all") {
                this.filteredProjects = this.filteredProjects.filter(
                    (project) => {
                        return (
                            project.tipoProgetto ==
                            this.projectsFilters.projectType
                        );
                    }
                );
            }

            let that = this;
            switch (this.projectsFilters.sortField) {
                case "NAME":
                    this.filteredProjects = this.filteredProjects.sort(
                        function (a, b) {
                            return that.projectsFilters.sortType == "ASC"
                                ? naturalCompare(
                                      a.titolo.toUpperCase(),
                                      b.titolo.toUpperCase()
                                  )
                                : naturalCompare(
                                      b.titolo.toUpperCase(),
                                      a.titolo.toUpperCase()
                                  );
                        }
                    );
                    break;

                case "DATE":
                    this.filteredProjects = this.filteredProjects.sort(
                        function (a, b) {
                            let diff =
                                moment(String(a.dataCreazione)) -
                                moment(String(b.dataCreazione));
                            let result = diff < 0 ? -1 : diff > 0 ? 1 : 0;
                            return that.projectsFilters.sortType == "ASC"
                                ? result
                                : -result;
                        }
                    );
                    break;
            }
        },

        filterProjectsByType(projectType) {
            this.projectsFilters.projectType = projectType;
            this.filterProjects();
        },

        filterProjectsBySort(sortField, sortType) {
            this.projectsFilters.sortField = sortField;
            this.projectsFilters.sortType = sortType;
            this.filterProjects();
        },

        onAddProject() {
            this.$router.push({
                name: "backend-gallery-search-projects",
                params: { eventId: this.eventId }
            });
        },

        editProjectShare(project) {
            this.$router.push({
                name: "backend-gallery-share-project",
                params: {
                    eventId: this.eventId,
                    projectId: project.idProgetto,
                    project: project,
                    mode: "edit", // modfica condivisione
                    gallery: this.gallery
                }
            });
        },

        removeProjectShare(projectId, i) {
            const h = this.$createElement;
            this.$bvModal
                .msgBoxConfirm(
                    [
                        h("div", {}, [
                            "Stai rimuovendo il progetto dall'evento e non sarà più visibile ai tuoi clienti."
                        ]),
                        h("div", { class: ["mt-1"] }, [
                            "Non preoccuparti, se cambi idea, potrai comunque aggiungerlo nuovamente in seguito."
                        ]),
                        h("div", { class: ["mt-1"] }, ["Vuoi procedere?"])
                    ],
                    {
                        title: "Attenzione!",
                        //size: "sm",
                        okVariant: "rikorda1",
                        okTitle: "Procedi",
                        cancelTitle: "Annulla",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true
                    }
                )
                .then((value) => {
                    // salvataggio confermato => chiamata api
                    if (value) {
                        this.$api
                            .backendRemoveProjectShare(this.eventId, projectId)
                            .then((response) => {
                                console.log(
                                    "BACKEND_REMOVE_PROJECT_SHARE",
                                    response
                                );
                                this.projects.splice(i, 1);
                            })
                            .catch((error) => {
                                console.error(
                                    "BACKEND_REMOVE_PROJECT_SHARE",
                                    error
                                );
                            });
                    }
                })
                .catch((err) => {
                    // An error occurred
                    console.error(err);
                });
        }
    },

    beforeRouteLeave(to, from, next) {
        if (this.isUploading || this.filesAdded) {
            this.$bvModal.show("upload-high-res-progress-modal");
            next(false);
        } else {
            next();
        }
    }
};
</script>

<style scoped>
.drop-area-container {
    overflow: hidden;
}

.drop-area-container .drop-area-msg {
    position: absolute;
    z-index: 1;
}

.drop-area-container .redarea-uploader {
    position: absolute;
    z-index: 100;
    height: 100%;
}

.gallery-photo-show div.img {
}

.gallery-photo-show img {
    width: 100%;
    height: auto;
}
</style>
